import getDisplayName from '../utils/getDisplayName'
import shallowEqual from 'fbjs/lib/shallowEqual'
import selectSearchHighlights from '../selectors/selectSearchHighlights'
import PropTypes from 'prop-types'
import React from 'react'

export default function searchTokenize(Component) {
  return class SearchTokenize extends React.Component {
    static displayName = `SearchTokenize(${getDisplayName(Component)})`
    static propTypes = {
      searchHighlightField: PropTypes.string,
      searchHighlights: PropTypes.array
    }

    shouldComponentUpdate(nextProps) {
      return !shallowEqual(this.props, nextProps)
    }

    render() {
      let { searchHighlights = [], searchHighlightField, ...props } = this.props
      searchHighlights = selectSearchHighlights(
        searchHighlights,
        searchHighlightField
      )

      const tokens = searchHighlights.reduce((memo, highlight) => {
        return memo.concat(highlight.tokens)
      }, [])

      return <Component tokens={tokens} {...props} />
    }
  }
}



// WEBPACK FOOTER //
// ../src/components/SearchTokenize.js